import { googleSiteVerification } from '@pkg/config/misc/googleSiteVerification';

export default defineAppConfig({
  icon: {
    mode: 'svg',
    size: '1em',
    class: '',
    // CMS icons ship with hard-coded fills; rewrite to currentColor for theme inheritance.
    customize(content: string, _name: string, prefix: string) {
      if (prefix === 'cms') {
        return content
          .replace(/(fill|stroke)="#[0-9a-fA-F]{3,8}"/g, '$1="currentColor"')
          .replace(/(fill|stroke):\s*#[0-9a-fA-F]{3,8}/g, '$1: currentColor');
      }
      return content;
    },
  },
  meta: {
    googleSiteVerification,
  },
});
